// extracted by mini-css-extract-plugin
module.exports = {"rich-text":"rich-text_rich-text__QyuIV","rich-text--text":"rich-text_rich-text--text__2BMGn"};